import { AppNameEnum } from '../api/apiTypes.shim';

interface DotEnvType {
  API: string;
  APP_NAME: string;
  APP_VERSION: string;
  ENV_NAME: string;
  SENTRY_ENABLED?: boolean;
  SERVICE_TITAN_ENTERPRISE_LOGIN_URL: string;
  disableRequestTimeout?: boolean;
}

type WindowWithDotEnv = typeof window & {
  DOTENV?: DotEnvType;
};

const dotenv = (window as WindowWithDotEnv).DOTENV;
// development vars
export const DEBUG = process.env.DEBUG === 'true';

// window.DOTENV driven vars
export const API_URL = dotenv?.API || process.env.API_URL || 'http://localhost:3000';
export const APP_NAME = dotenv?.APP_NAME || process.env.APP_NAME || AppNameEnum.CALL_PILOT;
export const ENV_NAME = dotenv?.ENV_NAME || process.env.ENV_NAME || 'local';
export const VERSION = dotenv?.APP_VERSION || process.env.VERSION || '0.0.1';
export const VERSION_DISPLAY = `v${VERSION}${DEBUG ? ` (${ENV_NAME})` : ''}`;
function getSentryDsn(appName: string): string {
  // TODO - Should we be creating a new project for the new react versions of callPilot/portal?
  const callPilotDsn = 'https://de7009bacf2a43b68c8d0b9fc9bf72e4@o304608.ingest.sentry.io/6060531';
  const portalDsn = 'https://e76527b2a04c41598813da044a9cb11c@o304608.ingest.sentry.io/6061645';
  if (appName === AppNameEnum.PORTAL) return portalDsn;
  if (appName === AppNameEnum.CALL_PILOT) return callPilotDsn;
  throw new Error(`Invalid APP_NAME (${APP_NAME}). Check build settings`);
}
export const SENTRY_DSN = getSentryDsn(APP_NAME);
export const SENTRY_ENABLED =
  dotenv?.SENTRY_ENABLED !== undefined ? dotenv.SENTRY_ENABLED : process.env.SENTRY_ENABLED === 'true';
export const SERVICE_TITAN_ENTERPRISE_LOGIN_URL =
  dotenv?.SERVICE_TITAN_ENTERPRISE_LOGIN_URL || 'https://enterprise-hub-qa-eh-telecom.qa.st.dev/';
export const disableRequestTimeout =
  dotenv?.disableRequestTimeout !== undefined
    ? dotenv.disableRequestTimeout
    : process.env.DISABLE_REQUEST_TIMEOUT === 'true';
